import clsx from "clsx";

// Matches the Certificate page badge palette so the registry and PDF stay in sync.
const STYLES = {
  pass:      { label: "Pass",      dot: "bg-[#2d5e1f]", pill: "bg-[#e6f1df] text-[#1f4715] border-[#2d5e1f]" },
  fail:      { label: "Fail",      dot: "bg-[#b30035]", pill: "bg-[#fbe4ea] text-[#7a0024] border-[#b30035]" },
  uncertain: { label: "Uncertain", dot: "bg-[#586673]", pill: "bg-[#EDF0F2] text-[#586673] border-[#586673]" },
  pending:   { label: "Pending",   dot: "bg-[#ccb795]", pill: "bg-[#f6efe2] text-[#50493b] border-[#ccb795]" },
};

function normalize(value) {
  const v = (value || "").trim().toLowerCase();
  if (v === "pass" || v === "passed") return "pass";
  if (v === "fail" || v === "failed") return "fail";
  if (v.startsWith("uncertain")) return "uncertain";
  return "pending";
}

export default function TestResultBadge({ value, size = "sm", label }) {
  const key = normalize(value);
  const s = STYLES[key];
  const displayLabel = label || (value || s.label);
  return (
    <span
      data-testid={`test-result-badge-${key}`}
      className={clsx(
        "inline-flex items-center gap-2 border rounded-sm subtitle uppercase tracking-[0.15em] max-w-full",
        s.pill,
        size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-[11px]",
      )}
    >
      <span className={clsx("h-1.5 w-1.5 shrink-0", s.dot)} />
      <span className="truncate">{displayLabel}</span>
    </span>
  );
}
